import { jwtDecode } from 'jwt-decode'
import { TokenWithPermissions } from '../../domain/models/TokenWithPermissions'

interface JWTPayload {
  sub: string
  scopes?: string[]
  exp: number
  [key: string]: any
}

/**
 * JWT implementation of TokenWithPermissions
 */
export class JWTToken extends TokenWithPermissions {
  getPermissions(): string[] {
    try {
      const payload = this.decodeJWTPayload()
      return payload.scopes ?? []
    } catch (error) {
      console.warn('Failed to decode JWT payload:', error)
      return []
    }
  }

  private decodeJWTPayload(): JWTPayload {
    return jwtDecode<JWTPayload>(this.value)
  }

  /**
   * Creates JWT access token with expiration from token payload
   */
  static createAccessToken(value: string): JWTToken {
    try {
      const payload = jwtDecode<JWTPayload>(value)
      const expiresAt = new Date(payload.exp * 1000) // JWT exp is in seconds
      return new JWTToken(value, 'access', expiresAt)
    } catch {
      // Fallback if decode fails
      return new JWTToken(value, 'access', null)
    }
  }
}
